async function loadcity( formurl, formdatas ){
  return new Promise((resolve, reject) => {
    return fetch( formurl, {
      cache: "no-store",
      method: "POST",
      body: formdatas,
    }).then( (response) => {
      return response.json();
    }).then( (response) => {
      resolve( response );
    }).catch( (error) => {
      reject( 'Erreur lors de du chargement des villes' );
    });
  });
}

DOMReady( function(){

  [... document.querySelectorAll('#account-layout #postal_code')].map( l => {
    l.addEventListener( 'keyup', function () {
      document.getElementById('fieldcity').innerHTML = '';
      if( l.value.length == 5 )
      {
        let formData = new FormData();
        formData.append('postal_code',l.value);
        loadcity( '/citiesfromcp/', formData ).then( ( data ) => {
          if( data.length )
          {
            let elt  = '<select name="locality" class="form-group form-input form-select">';
            data.forEach(row => {
            elt+='<option value="'+row+'">'+row+'</option>';
            });
            elt+='</select>';
            document.getElementById('fieldcity').innerHTML = elt;
          }
          else{
            document.getElementById('fieldcity').innerHTML = '<input type="text" name="locality" class="form-control account-input-text form-input"/>';
          }
        });
      }
    });
  });

  if(document.getElementById('updatepassword'))
  {
    document.getElementById('updatepassword').addEventListener('submit',function(e){
      document.querySelectorAll(".alert").forEach(el => el.remove());
      if(document.getElementsByClassName('isok').length < 5)
      {
        e.preventDefault();
        this.insertAdjacentHTML('beforeBegin',"<div class='alert alert-danger'><p>Le mot  de passe saisi n'est  pas conforme</p></div>");
        return false;
      }
    });
  }

  if(document.getElementById('inscriptionform'))
  {
    document.getElementById('inscriptionform').addEventListener('submit',function(e){
      document.querySelectorAll(".alert").forEach(el => el.remove());
      if(document.getElementsByClassName('isok').length < 5)
      {
        e.preventDefault();
        this.insertAdjacentHTML('beforeBegin',"<div class='alert alert-danger'><p>Le mot  de passe saisi n'est  pas conforme</p></div>");
        return false;
      }
    });
  }

  [... document.querySelectorAll('.toggle-password')].map( togglepassword => {
    togglepassword.addEventListener('click', (e)=>{
      let typePassword = togglepassword.dataset.password;

      let eyeElt = togglepassword.querySelector('.eye');
      let eyeBlockedElt = togglepassword.querySelector('.eye-blocked');

      if(eyeElt.style.display == 'block')
      {
        eyeBlockedElt.style.display = 'block';
        eyeElt.style.display = 'none';
        document.getElementById(typePassword).setAttribute('type','password');
      }
      else{
        eyeBlockedElt.style.display = 'none';
        eyeElt.style.display = 'block';
        document.getElementById(typePassword).setAttribute('type','text');

      }
    });
  });

  if(document.getElementById('is_pro'))
  {
    document.getElementById('is_pro').addEventListener('change',function(e){
      if(this.checked == 1)
      {
        let input = document.createElement('input');
        input.value = 1;
        input.name = "FAM__PRO";
        input.id = "fam_pro";
        input.type = "hidden";
        this.parentElement.append(input);
        document.getElementById('company').required = true;

         [... document.querySelectorAll('.form-group-pro')].map( group => {
          group.style.display = 'block';
        });
      }
      else{
        [... document.querySelectorAll('.form-group-pro')].map( group => {
          group.style.display = 'none';
        });  

        document.getElementById('company').required = false;
        document.getElementById('fam_pro').remove();
      }
      
    });
  }



  if(document.getElementById('new_password'))
  {
    document.getElementById('new_password').addEventListener('keyup',function(){
      if(this.value.match(/[A-Z]+/))
      {
        document.getElementById("upper").classList.remove('isnok');
        document.getElementById("upper").classList.add('isok');
      }
      else{
        document.getElementById("upper").classList.remove('isok');
        document.getElementById("upper").classList.add('isnok');
      }

      if(this.value.length > 7)
      {
        document.getElementById("minchar").classList.remove('isnok');
        document.getElementById("minchar").classList.add('isok');
      }
      else{
        document.getElementById("minchar").classList.remove('isok');
        document.getElementById("minchar").classList.add('isnok');
      }

      if(this.value.match(/[a-z]+/))
      {
        document.getElementById("lower").classList.remove('isnok');
        document.getElementById("lower").classList.add('isok');
      }
      else{
        document.getElementById("lower").classList.remove('isok');
        document.getElementById("lower").classList.add('isnok');
      }


      if(this.value.match(/\W+/))
      {
        document.getElementById("specialchar").classList.remove('isnok');
        document.getElementById("specialchar").classList.add('isok');
      }
      else{
        document.getElementById("specialchar").classList.remove('isok');
        document.getElementById("specialchar").classList.add('isnok');
      }

      if(this.value.match(/[0-9]+/))
      {
        document.getElementById("number").classList.remove('isnok');
        document.getElementById("number").classList.add('isok');
      }
      else{
        document.getElementById("number").classList.remove('isok');
        document.getElementById("number").classList.add('isnok');
      }
    });
  }

  if(document.querySelector('.info-abo #action')){
    [... document.querySelectorAll('.info-abo #action span')].map( spanclick => {
      spanclick.addEventListener('click',function(){
        let elt = document.querySelector('.info-abo #info-form-abo');
        if(elt.classList.contains('hide')){
          elt.classList.remove('hide');
          spanclick.innerHTML = '<svg role="img"  xmlns="http://www.w3.org/2000/svg" class="svgicon $identifier" height="24px" viewBox="0 -960 960 960" width="24px" fill="black"><path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z"/></svg>';
        }
        else{
          elt.classList.add('hide');
          spanclick.innerHTML = '<svg role="img" xmlns="http://www.w3.org/2000/svg" class="svgicon $identifier" height="24px" viewBox="0 -960 960 960" width="24px" fill="black"><path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/></svg>';
        }
      });
    })
  }
});
